<script setup>
import { useI18n } from 'vue-i18n';

// Ready-made phrases for a short field. Pointing at one shows it in the preview (`preview`), and a
// click puts it in the field (`apply`).
defineProps({
  phrases: { type: Array, required: true },
  modelValue: { type: String, default: '' },
});

const emit = defineEmits(['apply', 'preview']);

const { t } = useI18n();

const apply = phrase => {
  emit('apply', phrase);
  emit('preview', null);
};
</script>

<template>
  <div class="flex flex-wrap items-center gap-1.5">
    <span class="text-xs text-n-slate-11">
      {{ t('WHATSAPP_TEMPLATE_MGMT.CREATE.SHORTCUTS.LABEL') }}
    </span>
    <button
      v-for="phrase in phrases"
      :key="phrase"
      type="button"
      class="px-2 py-0.5 text-xs rounded-md transition-colors"
      :class="
        phrase === modelValue
          ? 'bg-n-teal-3 text-n-teal-11'
          : 'bg-n-alpha-2 text-n-slate-12 hover:bg-n-slate-4'
      "
      @mouseenter="emit('preview', phrase)"
      @mouseleave="emit('preview', null)"
      @focus="emit('preview', phrase)"
      @blur="emit('preview', null)"
      @click="apply(phrase)"
    >
      {{ phrase }}
    </button>
  </div>
</template>
